(function() { window.GUID_dfaa4d35_1df1_4c2a_9d40_fae37ade7329 = { getGuid: function() { return "dfaa4d35-1df1-4c2a-9d40-fae37ade7329"; } }; })();
var CS;
(function (CS) {
    class StaticTester {
        static Create() {
            if (!CS.StaticTester.Instance) {
                CS.StaticTester.Instance = new CS.StaticTester();
                CS.StaticTester.Instance.Id = 0;
            }
            $(() => {
                if (!CS.StaticTester.Instance) {
                }
            });
        }
        constructor() {
        }
    }
    CS.StaticTester = StaticTester;
})(CS || (CS = {}));

//# sourceMappingURL=cs-static.js.map
